import { useGlobalStore, useUserStore } from '@shared/store';
import { commonApi } from '../../apis';

// 初始化当前登录信息
export const initLoginContextInfo = async () => {
  try {
    const { ret, retdata = {} } = await commonApi.getLoginContextInfo<any, any>({});

    if (ret === 0) {
      useUserStore().setLoginContextInfo(retdata);
      useGlobalStore().setIsManagerView(retdata.staffId);
    }
  } catch (error) {
    console.log('初始化当前登录信息错误：', error);
  }
};
